import AddOnAPI from 'dashboard/api/addOns';
import { createStore } from 'dashboard/store/storeFactory';

export const useAddOnsStore = createStore({
  name: 'addOns',
  type: 'pinia',
  API: AddOnAPI,
});
